import { SystemService } from "./SystemService";
import AuthService from "./AuthService";
import { DionysosService } from "./DionysosService";

export const EXTRACTED_TYPE_TEMPLATES = {
    WIRE_SAWS: {
        name: 'ΣΥΡΜΑΤΟΚΟΠΕΣ',
        description: 'Μηχανήματα κοπής μαρμάρου με αδαμαντοφόρα σύρματα',
        category: 'ΜΗΧΑΝΗΜΑΤΑ',
        subcategory: 'ΣΥΡΜΑΤΟΚΟΠΗ',
        defaultWorkTypes: [],
    },
    DRILLS: {
        name: 'ΔΙΑΤΡΗΤΙΚΑ',
        description: 'Μηχανήματα διάτρησης & γεωτρύπανα',
        category: 'ΜΗΧΑΝΗΜΑΤΑ',
        subcategory: 'ΤΡΑΚΤΕΡ - WD - ΔΙΑΤΡΗΤΙΚΑ',
        defaultWorkTypes: [],
    },
    LOADERS: {
        name: 'ΦΟΡΤΩΤΕΣ',
        description: 'Φορτωτές και προωθητές',
        category: 'ΜΗΧΑΝΗΜΑΤΑ',
        subcategory: 'ΦΟΡΤΩΤΕΣ',
        defaultWorkTypes: [],
    },
    EXCAVATORS: {
        name: 'ΕΚΣΚΑΦΕΙΣ',
        description: 'Εκσκαφείς βαρέως τύπου & τσάπες',
        category: 'ΜΗΧΑΝΗΜΑΤΑ',
        subcategory: 'ΧΩΜΑΤΟΥΡΓΙΚΑ',
        defaultWorkTypes: [],
    },
    FORKLIFTS: {
        name: 'ΠΕΡΟΝΟΦΟΡΑ',
        description: 'Περονοφόρα ανυψωτικά οχήματα (Κλαρκ)',
        category: 'ΜΗΧΑΝΗΜΑΤΑ',
        subcategory: 'ΠΕΡΟΝΟΦΟΡΑ',
        defaultWorkTypes: [],
    },
    TANKERS: {
        name: 'ΥΔΡΟΦΟΡΕΣ & ΒΥΤΙΑ',
        description: 'Υδροφόρες, βυτιοφόρα νερού και πετρελαίου',
        category: 'ΦΟΡΤΗΓΑ',
        subcategory: 'ΕΙΔΙΚΩΝ ΧΡΗΣΕΩΝ',
        defaultWorkTypes: [],
    },
    CRANES: {
        name: 'ΓΕΡΑΝΟΦΟΡΑ',
        description: 'Γερανοφόρα οχήματα και γερανογέφυρες',
        category: 'ΦΟΡΤΗΓΑ',
        subcategory: 'ΕΙΔΙΚΩΝ ΧΡΗΣΕΩΝ',
        defaultWorkTypes: [],
    },
    COMPRESSORS: {
        name: 'ΑΕΡΟΣΥΜΠΙΕΣΤΕΣ',
        description: 'Αεροσυμπιεστές πετρελαιοκίνητοι & ηλεκτροκίνητοι',
        category: 'ΜΗΧΑΝΗΜΑΤΑ',
        subcategory: 'ΠΕΤΡΕΛΑΙΟΚΙΝΗΤΟΙ',
        defaultWorkTypes: [],
    },
    GENERATORS: {
        name: 'ΗΛΕΚΤΡΟΠΑΡΑΓΩΓΑ ΖΕΥΓΗ',
        description: 'Ηλεκτροπαραγωγά ζεύγη και γεννήτριες',
        category: 'ΜΗΧΑΝΗΜΑΤΑ',
        subcategory: 'ΗΛΕΚΤΡΟΠΑΡΑΓΩΓΑ',
        defaultWorkTypes: [],
    },
    PROCESSING: {
        name: 'ΜΗΧΑΝΗΜΑΤΑ ΕΠΕΞΕΡΓΑΣΙΑΣ',
        description: 'Κόφτες, φρέζες, τελάρα και λειαντικά επεξεργασίας',
        category: 'ΜΗΧΑΝΗΜΑΤΑ',
        subcategory: 'ΕΠΕΞΕΡΓΑΣΙΑ',
        defaultWorkTypes: [],
    },
    TRUCKS: {
        name: 'ΦΟΡΤΗΓΑ & DUMPER',
        description: 'Φορτηγά μεταφοράς, ανατρεπόμενα & dumper',
        category: 'ΦΟΡΤΗΓΑ',
        subcategory: 'ΜΕΤΑΦΟΡΑΣ ΠΡΟΙΟΝΤΩΝ',
        defaultWorkTypes: [],
    },
    BUSES: {
        name: 'ΛΕΩΦΟΡΕΙΑ & MINIBUS',
        description: 'Οχήματα μεταφοράς προσωπικού',
        category: 'ΛΕΩΦΟΡΕΙΑ',
        subcategory: 'ΜΕΤΑΦΟΡΑ ΠΡΟΣΩΠΙΚΟΥ',
        defaultWorkTypes: [],
    },
    UTILITY: {
        name: 'ΕΠΙΒΑΤΙΚΑ & ΗΜΙΦΟΡΤΗΓΑ',
        description: 'Επιβατικά και βοηθητικά οχήματα υπηρεσίας',
        category: 'ΕΠΙΒΑΤΙΚΟ ΑΥΤΟΚΙΝΗΤΟ',
        subcategory: 'ΗΜΙΦΟΡΤΗΓΑ',
        defaultWorkTypes: [],
    },
    OTHER: {
        name: 'ΛΟΙΠΑ ΜΗΧΑΝΗΜΑΤΑ',
        description: 'Λοιπά μηχανήματα και εξοπλισμός παραγωγής',
        category: 'ΜΗΧΑΝΗΜΑΤΑ',
        subcategory: 'ΑΥΤΟΚΙΝΟΥΜΕΝΑ',
        defaultWorkTypes: [],
    },
};

export function classifyMachine(m) {
    const desc = (m?.Description || '').trim();
    const c1 = (m?.Code1 || '').trim();
    const c2 = (m?.Code2 || '').trim();

    if (c2) {
        return {
            name: c2,
            description: desc || c2,
            category: c1 || undefined,
            subcategory: c2,
            defaultWorkTypes: [],
        };
    }

    if (c1) {
        return {
            name: c1,
            description: desc || c1,
            category: c1,
            subcategory: undefined,
            defaultWorkTypes: [],
        };
    }

    return {
        name: desc || 'ΛΟΙΠΑ',
        description: desc || 'Λοιπά μηχανήματα',
        category: undefined,
        subcategory: undefined,
        defaultWorkTypes: [],
    };
}

const STORAGE_KEY = 'nordia_cached_machine_types';

function getStorageKey(wh) {
    return wh ? `${STORAGE_KEY}_${wh}` : STORAGE_KEY;
}

function getCachedTypes(wh) {
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            const item = localStorage.getItem(getStorageKey(wh));
            if (item) {
                const parsed = JSON.parse(item);
                if (Array.isArray(parsed)) return parsed;
            }
            if (wh) {
                const globalItem = localStorage.getItem(STORAGE_KEY);
                if (globalItem) {
                    const parsed = JSON.parse(globalItem);
                    if (Array.isArray(parsed)) return parsed.filter(t => !t.wh || t.wh === wh);
                }
            }
        }
    } catch (e) {
        console.warn('Failed to parse cached machine types from localStorage', e);
    }
    return [];
}

function saveCachedTypes(types, wh) {
    try {
        if (typeof window !== 'undefined' && window.localStorage && Array.isArray(types)) {
            localStorage.setItem(getStorageKey(wh), JSON.stringify(types));
        }
    } catch (e) {
        console.warn('Failed to save machine types to localStorage', e);
    }
}

class MachineTypesService {
    systemService = null;
    api = null;
    authService = null;

    constructor() {
        this.systemService = new SystemService();
        this.authService = new AuthService();
        this.api = this.systemService.getApiAccess();
    }

    async requestWithFallback(method, pathAliases, data = null) {
        const sessionId = this.authService.getSessionId();
        const headers = sessionId ? { authorization: sessionId } : {};
        let lastError = null;

        for (const path of pathAliases) {
            try {
                let response;
                if (method === 'get') {
                    response = await this.api.get(path, { headers });
                } else if (method === 'post') {
                    response = await this.api.post(path, data, { headers });
                } else if (method === 'put') {
                    response = await this.api.put(path, data, { headers });
                } else if (method === 'delete') {
                    response = await this.api.delete(path, { headers });
                }
                if (response && response.data !== undefined) {
                    return response.data;
                }
            } catch (err) {
                lastError = err;
                if (err.response && err.response.status !== 404) {
                    throw err;
                }
            }
        }
        throw lastError || new Error(`Failed request to ${pathAliases[0]}`);
    }

    async getMachineTypes(wh) {
        const targetWh = wh !== undefined ? wh : this.authService.getConfig()?.whCode;
        const queryParams = targetWh ? `?wh=${targetWh}` : '';
        try {
            const data = await this.requestWithFallback('get', [
                `machine-types${queryParams}`,
                `machinetypes${queryParams}`,
                `machine_types${queryParams}`,
                `machines/types${queryParams}`
            ]);
            if (Array.isArray(data)) {
                saveCachedTypes(data, targetWh);
                return data;
            }
        } catch (e) {
            console.warn('MachineTypesService: Could not load machine types from server, using local fallback', e);
        }

        const cached = getCachedTypes(targetWh);
        if (cached && cached.length > 0) {
            return cached;
        }

        return [];
    }

    async clientSideExtractFromMachines(wh) {
        try {
            const dionysosService = new DionysosService();
            const targetWh = wh !== undefined ? wh : this.authService.getConfig()?.whCode;
            const machines = await dionysosService.getMachines(targetWh).catch(() => []);
            const machineList = Array.isArray(machines) ? machines : (Array.isArray(machines?.data) ? machines.data : []);

            const existingTypeList = getCachedTypes(targetWh);
            const existingBySubcat = new Map();
            const existingByName = new Map();
            for (const t of existingTypeList) {
                if (t && t.subcategory) {
                    existingBySubcat.set(t.subcategory.trim().toUpperCase(), t);
                }
                if (t && t.name) {
                    existingByName.set(t.name.trim().toUpperCase(), t);
                }
            }

            const groups = new Map();

            for (const m of machineList) {
                if (!m || !m.Code) continue;
                const c2 = (m.Code2 || '').trim();
                const c1 = (m.Code1 || '').trim();

                // Distinct Code2s are the types in the list
                if (!c2) continue;

                const key = c2.toUpperCase();
                if (!groups.has(key)) {
                    groups.set(key, {
                        name: c2,
                        subcategory: c2,
                        category: c1 || '',
                        description: c2,
                        codes: new Set()
                    });
                }
                const g = groups.get(key);
                g.codes.add(m.Code);
                if (!g.category && c1) {
                    g.category = c1;
                }
            }

            const resultTypes = [];
            let currentId = 1;

            for (const [key, group] of groups.entries()) {
                const { name, category, subcategory, description, codes } = group;
                const codeArray = Array.from(codes);
                let existing = null;
                if (subcategory) {
                    existing = existingBySubcat.get(subcategory.toUpperCase());
                }
                if (!existing) {
                    existing = existingByName.get(name.toUpperCase());
                }

                if (existing) {
                    const updated = {
                        ...existing,
                        name: name,
                        description: existing.description || description || name,
                        category: category || existing.category,
                        subcategory: subcategory,
                        wh: targetWh,
                        machineCodes: codeArray,
                        workTypes: existing.workTypes || []
                    };
                    resultTypes.push(updated);
                } else {
                    const newId = currentId++;
                    const created = {
                        id: newId,
                        name,
                        description: description || name,
                        category,
                        subcategory,
                        wh: targetWh,
                        machineCodes: codeArray,
                        workTypes: []
                    };
                    resultTypes.push(created);
                }
            }

            saveCachedTypes(resultTypes, targetWh);
            return resultTypes;
        } catch (err) {
            console.error('Client-side extraction fallback error:', err);
            return getCachedTypes(wh);
        }
    }

    async seedDefaults(wh) {
        return this.extractFromMachines(wh);
    }

    async extractFromMachines(wh) {
        const targetWh = wh !== undefined ? wh : this.authService.getConfig()?.whCode;
        const queryParams = targetWh ? `?wh=${targetWh}` : '';
        try {
            const data = await this.requestWithFallback('post', [
                `machine-types/extract-from-machines${queryParams}`,
                `machine-types/extract${queryParams}`,
                `machine-types/seed-defaults${queryParams}`,
                `machinetypes/extract-from-machines${queryParams}`,
                `machine_types/extract-from-machines${queryParams}`,
                `machines/types/extract-from-machines${queryParams}`
            ], targetWh ? { wh: targetWh } : undefined);
            if (Array.isArray(data)) {
                saveCachedTypes(data, targetWh);
                return data;
            }
        } catch (e) {
            console.warn('MachineTypesService: extractFromMachines backend endpoint unavailable, falling back locally', e);
        }
        return await this.clientSideExtractFromMachines(targetWh);
    }

    async getMachineType(id) {
        const numId = Number(id);
        try {
            const data = await this.requestWithFallback('get', [
                `machine-types/${id}`,
                `machinetypes/${id}`,
                `machine_types/${id}`,
                `machines/types/${id}`
            ]);
            return data;
        } catch (e) {
            const cached = getCachedTypes();
            const found = cached.find(t => t.id === numId);
            if (found) return found;
            const msg = e.response?.data?.message || e.message || 'Error fetching machine type';
            throw new Error(msg);
        }
    }

    async createMachineType(data) {
        const targetWh = data.wh !== undefined ? data.wh : this.authService.getConfig()?.whCode;
        const payload = { ...data, wh: targetWh };
        try {
            const res = await this.requestWithFallback('post', [
                'machine-types',
                'machinetypes',
                'machine_types',
                'machines/types'
            ], payload);
            const cached = getCachedTypes(targetWh);
            const updated = [...cached.filter(t => t.id !== res.id), res];
            saveCachedTypes(updated, targetWh);
            return res;
        } catch (e) {
            const cached = getCachedTypes(targetWh);
            const newItem = {
                id: Date.now(),
                ...payload,
                workTypes: data.workTypes || []
            };
            const updated = [...cached, newItem];
            saveCachedTypes(updated, targetWh);
            return newItem;
        }
    }

    async updateMachineType(id, data) {
        const numId = Number(id);
        try {
            const res = await this.requestWithFallback('put', [
                `machine-types/${id}`,
                `machinetypes/${id}`,
                `machine_types/${id}`,
                `machines/types/${id}`
            ], data);
            const cached = getCachedTypes(res.wh);
            const updated = cached.map(t => (t.id === numId ? { ...t, ...res } : t));
            saveCachedTypes(updated, res.wh);
            return res;
        } catch (e) {
            const cached = getCachedTypes(data.wh);
            let updatedItem = null;
            const updated = cached.map(t => {
                if (t.id === numId) {
                    updatedItem = { ...t, ...data };
                    return updatedItem;
                }
                return t;
            });
            saveCachedTypes(updated, data.wh);
            return updatedItem || { id: numId, ...data };
        }
    }

    async deleteMachineType(id) {
        const numId = Number(id);
        try {
            const res = await this.requestWithFallback('delete', [
                `machine-types/${id}`,
                `machinetypes/${id}`,
                `machine_types/${id}`,
                `machines/types/${id}`
            ]);
            const cached = getCachedTypes();
            saveCachedTypes(cached.filter(t => t.id !== numId));
            return res;
        } catch (e) {
            const cached = getCachedTypes();
            saveCachedTypes(cached.filter(t => t.id !== numId));
            return { success: true };
        }
    }

    async addWorkType(machineTypeId, data) {
        const numId = Number(machineTypeId);
        try {
            const res = await this.requestWithFallback('post', [
                `machine-types/${machineTypeId}/work-types`,
                `machinetypes/${machineTypeId}/work-types`,
                `machine_types/${machineTypeId}/work-types`,
                `machines/types/${machineTypeId}/work-types`
            ], data);
            const cached = getCachedTypes();
            const updated = cached.map(t => {
                if (t.id === numId) {
                    const existingWorkTypes = Array.isArray(t.workTypes) ? t.workTypes : [];
                    return { ...t, workTypes: [...existingWorkTypes.filter(w => w.id !== res.id), res] };
                }
                return t;
            });
            saveCachedTypes(updated);
            return res;
        } catch (e) {
            const newWorkType = {
                id: Date.now(),
                machineTypeId: numId,
                ...data
            };
            const cached = getCachedTypes();
            const updated = cached.map(t => {
                if (t.id === numId) {
                    const existingWorkTypes = Array.isArray(t.workTypes) ? t.workTypes : [];
                    return { ...t, workTypes: [...existingWorkTypes, newWorkType] };
                }
                return t;
            });
            saveCachedTypes(updated);
            return newWorkType;
        }
    }

    async updateWorkType(workTypeId, data) {
        const numId = Number(workTypeId);
        try {
            const res = await this.requestWithFallback('put', [
                `machine-types/work-types/${workTypeId}`,
                `machinetypes/work-types/${workTypeId}`,
                `machine_types/work-types/${workTypeId}`,
                `machines/types/work-types/${workTypeId}`
            ], data);
            const cached = getCachedTypes();
            const updated = cached.map(t => {
                if (Array.isArray(t.workTypes)) {
                    return {
                        ...t,
                        workTypes: t.workTypes.map(w => (w.id === numId ? { ...w, ...res } : w))
                    };
                }
                return t;
            });
            saveCachedTypes(updated);
            return res;
        } catch (e) {
            const cached = getCachedTypes();
            let updatedWorkType = null;
            const updated = cached.map(t => {
                if (Array.isArray(t.workTypes)) {
                    return {
                        ...t,
                        workTypes: t.workTypes.map(w => {
                            if (w.id === numId) {
                                updatedWorkType = { ...w, ...data };
                                return updatedWorkType;
                            }
                            return w;
                        })
                    };
                }
                return t;
            });
            saveCachedTypes(updated);
            return updatedWorkType || { id: numId, ...data };
        }
    }

    async deleteWorkType(workTypeId) {
        const numId = Number(workTypeId);
        try {
            const res = await this.requestWithFallback('delete', [
                `machine-types/work-types/${workTypeId}`,
                `machinetypes/work-types/${workTypeId}`,
                `machine_types/work-types/${workTypeId}`,
                `machines/types/work-types/${workTypeId}`
            ]);
            const cached = getCachedTypes();
            const updated = cached.map(t => {
                if (Array.isArray(t.workTypes)) {
                    return {
                        ...t,
                        workTypes: t.workTypes.filter(w => w.id !== numId)
                    };
                }
                return t;
            });
            saveCachedTypes(updated);
            return res;
        } catch (e) {
            const cached = getCachedTypes();
            const updated = cached.map(t => {
                if (Array.isArray(t.workTypes)) {
                    return {
                        ...t,
                        workTypes: t.workTypes.filter(w => w.id !== numId)
                    };
                }
                return t;
            });
            saveCachedTypes(updated);
            return { success: true };
        }
    }

    async getWorkTypesForMachine(machineCode) {
        if (!machineCode) return [];
        const normalizedCode = machineCode.trim().toUpperCase();
        try {
            const data = await this.requestWithFallback('get', [
                `machine-types/for-machine/${encodeURIComponent(normalizedCode)}`,
                `machinetypes/for-machine/${encodeURIComponent(normalizedCode)}`,
                `machine_types/for-machine/${encodeURIComponent(normalizedCode)}`,
                `machines/types/for-machine/${encodeURIComponent(normalizedCode)}`
            ]);
            if (Array.isArray(data)) {
                return data;
            }
        } catch (e) {
            // Fallback
        }

        const cachedTypes = await this.getMachineTypes().catch(() => getCachedTypes());
        for (const mt of cachedTypes) {
            if (mt && mt.machineCodes) {
                const codes = (Array.isArray(mt.machineCodes) ? mt.machineCodes : mt.machineCodes.split(',')).map(c => c.trim().toUpperCase());
                if (codes.includes(normalizedCode)) {
                    return mt.workTypes || [];
                }
            }
        }

        // Match by machine's subcategory (Code2) first
        try {
            const dionysosService = new DionysosService();
            const machines = await dionysosService.getMachines().catch(() => []);
            const machineList = Array.isArray(machines) ? machines : (Array.isArray(machines?.data) ? machines.data : []);
            const match = machineList.find(m => (m?.Code || '').toUpperCase() === normalizedCode);
            if (match) {
                const desc = (match.Description || '').toUpperCase();
                const c1 = (match.Code1 || '').toUpperCase();
                const c2 = (match.Code2 || '').toUpperCase();

                if (c2) {
                    for (const mt of cachedTypes) {
                        const typeSub = (mt.subcategory || '').toUpperCase();
                        const typeName = (mt.name || '').toUpperCase();
                        if (typeSub && (c2 === typeSub || c2.includes(typeSub) || typeSub.includes(c2))) {
                            return mt.workTypes || [];
                        }
                        if (typeName && (c2.includes(typeName) || typeName.includes(c2))) {
                            return mt.workTypes || [];
                        }
                    }
                }

                for (const mt of cachedTypes) {
                    const typeName = (mt.name || '').toUpperCase();
                    const typeSub = (mt.subcategory || '').toUpperCase();
                    const typeCat = (mt.category || '').toUpperCase();
                    if (typeSub && desc.includes(typeSub)) return mt.workTypes || [];
                    if (typeName && desc.includes(typeName)) return mt.workTypes || [];
                    if (typeCat && desc.includes(typeCat)) return mt.workTypes || [];
                }

                if (c1) {
                    for (const mt of cachedTypes) {
                        const typeCat = (mt.category || '').toUpperCase();
                        if (typeCat && (c1 === typeCat || c1.includes(typeCat))) {
                            return mt.workTypes || [];
                        }
                    }
                }
            }
        } catch (e) {
            // Ignore
        }

        return [];
    }
}

export default MachineTypesService;
